import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { FiUploadCloud, FiX } from "react-icons/fi";
import { AiOutlineFileText } from "react-icons/ai";
import { toast } from "react-toastify";

const AddDocumentForm = ({
  initialData = null,
  onSubmit,
  onCancel,
  requireFile = true,
}) => {
  const [form, setForm] = useState({
    title: "",
    description: "",
    category: "",
    active: true,
  });
  const [file, setFile] = useState(null);
  const [filePreview, setFilePreview] = useState(null);
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);

  useEffect(() => {
    if (initialData) {
      setForm({
        title: initialData.title || "",
        description: initialData.description || "",
        category: initialData.category || "",
        active: initialData.active ?? true,
      });
      setImagePreview(initialData.imageUrl || initialData.thumbnail || null);
      // Agar oldingi fayl mavjud bo'lsa faqat nomini ko'rsatamiz (haqiqiy faylni qayta yuklay olmaymiz)
      setFilePreview(
        initialData.fileUrl || initialData.fileName
          ? { name: initialData.fileName || "Oldingi fayl" }
          : null
      );
      setFile(null);
      setImage(null);
    } else {
      setForm({ title: "", description: "", category: "", active: true });
      setFile(null);
      setFilePreview(null);
      setImage(null);
      setImagePreview(null);
    }
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleFile = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    if (selectedFile.size > 50 * 1024 * 1024) {
      toast.error("Fayl hajmi 50MB dan oshmasligi kerak!");
      return;
    }

    setFile(selectedFile);
    setFilePreview({
      name: selectedFile.name,
      size: (selectedFile.size / 1024 / 1024).toFixed(1) + " MB",
    });
  };

  const handleImage = (e) => {
    const selectedImage = e.target.files[0];
    if (!selectedImage) return;

    if (selectedImage.size > 10 * 1024 * 1024) {
      toast.error("Rasm hajmi 10MB dan oshmasligi kerak!");
      return;
    }

    setImage(selectedImage);
    setImagePreview(URL.createObjectURL(selectedImage));
  };

  const removeFile = () => {
    setFile(null);
    setFilePreview(null);
  };

  const removeImage = () => {
    setImage(null);
    setImagePreview(null);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (requireFile && !file && !filePreview) {
      toast.error("Hujjat faylini yuklash majburiy!");
      return;
    }

    if (!form.title.trim()) {
      toast.error("Hujjat nomini kiriting!");
      return;
    }

    onSubmit({ ...form, file, image });
  };

  return (
    <motion.form
      className="banner-form"
      onSubmit={handleSubmit}
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <div className="form-grid">
        <div className="form-item">
          <label>Hujjat nomi *</label>
          <input
            name="title"
            value={form.title}
            onChange={handleChange}
            placeholder="Masalan: Matematika 7-sinf dars rejasi"
            required
          />
        </div>

        <div className="form-item">
          <label>Kategoriya</label>
          <select name="category" value={form.category} onChange={handleChange}>
            <option value="">Tanlang</option>
            <option value="O'quv dasturi">O'quv dasturi</option>
            <option value="Dars rejasi">Dars rejasi</option>
            <option value="Baholash mezonlari">Baholash mezonlari</option>
            <option value="Metodik qo'llanma">Metodik qo'llanma</option>
            <option value="Testlar va topshiriqlar">Testlar va topshiriqlar</option>
            <option value="Boshqa">Boshqa</option>
          </select>
        </div>

        <div className="form-item full-width">
          <label>Tavsif (ixtiyoriy)</label>
          <textarea
            name="description"
            rows="5"
            placeholder="Hujjat haqida qisqacha ma'lumot..."
            value={form.description}
            onChange={handleChange}
          />
        </div>

        <div className="form-item full-width">
          <label>Hujjat fayli {requireFile ? "*" : ""}</label>
          <div className="image-upload-box">
            {filePreview ? (
              <div
                style={{
                  position: "relative",
                  padding: "16px",
                  background: "#f8fafc",
                  borderRadius: "14px",
                  border: "1px solid #e2e8f0",
                  display: "flex",
                  alignItems: "center",
                  gap: "16px",
                }}
              >
                <AiOutlineFileText size={48} color="#6366f1" />
                <div style={{ flex: 1 }}>
                  <div
                    style={{
                      fontSize: "16px",
                      fontWeight: 600,
                      color: "#1f2937",
                      marginBottom: "4px",
                    }}
                  >
                    {filePreview.name}
                  </div>
                  <div style={{ fontSize: "14px", color: "#6b7280" }}>
                    {filePreview.size}
                  </div>
                </div>

                <motion.button
                  whileHover={{ scale: 1.15 }}
                  whileTap={{ scale: 0.9 }}
                  type="button"
                  onClick={removeFile}
                  style={{
                    background: "rgba(220, 38, 38, 0.9)",
                    color: "white",
                    border: "none",
                    width: 38,
                    height: 38,
                    borderRadius: "50%",
                    fontSize: 20,
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  ×
                </motion.button>
              </div>
            ) : (
              <motion.div
                className="upload-placeholder"
                whileHover={{ scale: 1.03, backgroundColor: "#f0f7ff" }}
                whileTap={{ scale: 0.97 }}
                onClick={() => document.getElementById("fileInput").click()}
                style={{
                  height: "220px",
                  border: "3px dashed #cbd5e1",
                  borderRadius: "16px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "#f8fafc",
                  cursor: "pointer",
                  gap: 12,
                }}
              >
                <FiUploadCloud size={52} color="#6366f1" />
                <p
                  style={{
                    margin: 0,
                    fontSize: 17,
                    fontWeight: 600,
                    color: "#374151",
                  }}
                >
                  Fayl yuklash uchun bosing
                </p>
                <span style={{ fontSize: 14, color: "#94a3b8" }}>
                  PDF, Word, Excel, PowerPoint • Maks 50MB
                </span>
              </motion.div>
            )}

            <input
              id="fileInput"
              type="file"
              accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
              hidden
              onChange={handleFile}
            />
          </div>
        </div>

        <div className="form-item full-width">
          <label>Muqova rasmi (ixtiyoriy)</label>
          <div className="image-upload-box">
            {imagePreview ? (
              <div style={{ position: "relative", display: "inline-block" }}>
                <img
                  src={imagePreview}
                  alt="Muqova rasm"
                  style={{
                    width: "100%",
                    height: "260px",
                    objectFit: "cover",
                    borderRadius: "14px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                  }}
                />
                <motion.button
                  whileHover={{ scale: 1.15 }}
                  whileTap={{ scale: 0.9 }}
                  type="button"
                  onClick={removeImage}
                  style={{
                    position: "absolute",
                    top: 12,
                    right: 12,
                    background: "rgba(220, 38, 38, 0.9)",
                    color: "white",
                    border: "none",
                    width: 38,
                    height: 38,
                    borderRadius: "50%",
                    fontSize: 20,
                    cursor: "pointer",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                  }}
                >
                  ×
                </motion.button>
              </div>
            ) : (
              <motion.div
                className="upload-placeholder"
                whileHover={{ scale: 1.03, backgroundColor: "#f0f7ff" }}
                whileTap={{ scale: 0.97 }}
                onClick={() => document.getElementById("imgInput").click()}
                style={{
                  height: "260px",
                  border: "3px dashed #cbd5e1",
                  borderRadius: "16px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "#f8fafc",
                  cursor: "pointer",
                  gap: 12,
                }}
              >
                <FiUploadCloud size={48} color="#6366f1" />
                <p
                  style={{
                    margin: 0,
                    fontSize: 16,
                    fontWeight: 600,
                    color: "#374151",
                  }}
                >
                  Rasm tanlash (ixtiyoriy)
                </p>
                <span style={{ fontSize: 13, color: "#94a3b8" }}>
                  JPG, PNG • Maks 10MB
                </span>
              </motion.div>
            )}

            <input
              id="imgInput"
              type="file"
              accept="image/*"
              hidden
              onChange={handleImage}
            />
          </div>
        </div>

        <div className="form-buttons">
          <button type="submit" className="save">
            {initialData ? "Yangilash" : "Saqlash"}
          </button>
          <button type="button" className="cancel" onClick={onCancel}>
            Bekor qilish
          </button>
        </div>
      </div>
    </motion.form>
  );
};

export default AddDocumentForm;